export const EXPENSE_PAYEE_TYPE = {
  SUPPLIER: 'supplier',
  EMPLOYEE: 'employee'
}